const getName = (option = {}) => {
  let res;
  if (option.surName?.trim() && option.firstName?.trim()) {
    res = `${option.surName} ${option.firstName?.[0]}.`;
    if (option.patrName?.trim()) {
      res = res + ' ' + option.patrName[0] + '.';
    }
    return res;
  }
  if (option.surName || option.firstName) {
    return option.surName || option.firstName;
  }
  if (option.fullName) {
    return option.fullName;
  }
  if (option.description) {
    return option.description;
  }
  return option.name;
};

export default getName;
